var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "has-logo": _vm.showLogo, heightShow: _vm.heightFlag } },
    [
      _vm.showLogo
        ? _c("logo", { attrs: { collapse: _vm.isCollapse } })
        : _vm._e(),
      _c(
        "el-scrollbar",
        { attrs: { "wrap-class": "scrollbar-wrapper" } },
        [
          _c(
            "el-menu",
            {
              attrs: {
                "default-openeds": _vm.getopenMenuArr,
                "default-active": _vm.activeMenu,
                collapse: _vm.isCollapse,
                "background-color": _vm.variables.menuBg,
                "unique-opened": false,
                "active-text-color": "var(--mainColor)",
                "collapse-transition": false,
                mode: "vertical"
              },
              on: {
                select: _vm.handleSelect,
                open: _vm.handleOpen,
                close: _vm.handleClose
              }
            },
            [
              _vm._l(_vm.getMenuArr, function(item, i) {
                return _c("sidebar-item", {
                  key: i,
                  attrs: { item: item, "base-path": item.path }
                })
              }),
              _c("div", { staticStyle: { width: "1px", height: "40px" } })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }